import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/layout-fixes.css'; // Import the layout fixes
import './styles/animations.css'; // Import animations
import './styles/precise-height-calc.css'; // Import precise content height calculation
import './styles/header-spacing.css'; // Import header spacing fixes
import './styles/global-header-spacing.css'; // Import global header spacing for all pages
import './styles/exact-tile-spacing.css'; // Import exact 24px tile spacing
import './styles/fix-tile-spacing-24px.css'; // Import fix for 24px tile spacing (final fix)
import './styles/section-divider.css'; // Import section divider styles
import App from './App';
import reportWebVitals from './reportWebVitals';

// Log the actual port being used (this helps in development)
// console.log(`Frontend running on port: ${process.env.PORT || window.location.port || '3000'}`);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
